import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@material-ui/core";
import dayjs from "dayjs";
import {
  ArrowUpward as UpIcon,
  ArrowDownward as DownIcon,
} from "@material-ui/icons";

function CompDashCard({ title, valorAtual, valorAnterior, upValue = false }) {
  const thisMonth = (number) => {
    switch (number) {
      case 1:
        return "Janeiro";
      case 2:
        return "Fevereiro";
      case 3:
        return "Março";
      case 4:
        return "Abril";
      case 5:
        return "Maio";
      case 6:
        return "Junho";
      case 7:
        return "Julho";
      case 8:
        return "Agosto";
      case 9:
        return "Setembro";
      case 10:
        return "Outubro";
      case 11:
        return "Novembro";
      case 12:
        return "Dezembro";
    }
  };

  return (
    <Card style={{ height: "140px" }}>
      <CardHeader title={title} />
      <Divider />
      <CardContent>
        <Grid container item justify="space-between">
          <Grid item sm={5} style={{ padding: 5 }}>
            <Typography
              variant="button"
              style={{ display: "flex", textAlign: "center" }}
            >
              {valorAnterior}
            </Typography>
            <Typography
              variant="overline"
              style={{ display: "flex", textAlign: "center", color: "#999" }}
            >
              {thisMonth(parseInt(dayjs().subtract(1, "month").format("MM")))}
            </Typography>
          </Grid>
          <Grid
            container
            item
            sm={2}
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Divider orientation="vertical" />
            {upValue ? (
              <UpIcon style={{ color: "rgb(55, 99, 132)" }} />
            ) : (
              <DownIcon style={{ color: "rgb(255, 99, 132)" }} />
            )}
            <Divider orientation="vertical" />
          </Grid>
          <Grid item sm={5} style={{ padding: 5 }}>
            <Typography
              variant="button"
              style={{
                display: "flex",
                textAlign: "center",
                color: upValue ? "rgb(55, 99, 132)" : "rgb(255, 99, 132)",
              }}
            >
              {valorAtual}
            </Typography>
            <Typography
              variant="overline"
              style={{ display: "flex", textAlign: "center", color: "#999" }}
            >
              {thisMonth(parseInt(dayjs().format("MM")))}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default CompDashCard;
